//@flow

import * as React from 'react';

import { injectScale } from './ScaleContext';

type Props = {
  scale: number,
  children: React.Node,
};

class PizzaKitchen extends React.PureComponent<Props> {
  render() {
    const style = {
      height: this.props.scale * 474,
      width: this.props.scale * 864,
    };
    return (
      <div className="pizza-background pizza-kitchen" style={style}>
        {this.props.children}
      </div>
    );
  }
}

export default injectScale(PizzaKitchen);
